var HeroSection = new Swiper(".hero-slider", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 15,
  autoHeight: true, 
  autoplay: {
    delay: 5000,
  }
}); 

var VideoTestimonial = new Swiper(".videoimage-testimonial-slider", {
  loop:false,
  slidesPerView: 1.5,
  spaceBetween: 15,
  navigation: {
    nextEl: ".videoimage-testimonial-wrap .swiper-button-next",
    prevEl: ".videoimage-testimonial-wrap .swiper-button-prev"
  },
  breakpoints: {
    749: {
      slidesPerView: 2,
      spaceBetween: 20
    } 
  }
});

var ImageIconColumnSlider = new Swiper(".image-icon-column-slider", {
  loop:false,
  slidesPerView: 1.2,
  spaceBetween: 15,
  navigation: {
    nextEl: ".column-slider-wrap .swiper-button-next",
    prevEl: ".column-slider-wrap .swiper-button-prev"
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    } 
  }
});

// Logo
// var benefitswiper = new Swiper(".partners-logo-wrapper", {
//   loop:true,
//   slidesPerView: 'auto',
//   spaceBetween: 20,
//   allowTouchMove: false,
//   speed: 5000,
//   autoplay: {
//     delay: 0, 
//     disableOnInteraction: false,
//     pauseOnMouseEnter: false, 
//   }
// });
// Logo 



document.addEventListener('DOMContentLoaded', function () {
  const landingPopup = document.querySelector('.landing-popup');
  const popupOverlay = document.querySelector('.popup-overlay');
  const closeButton = document.querySelector('.landing-popup-close-button');

  if (!landingPopup || !popupOverlay || !closeButton) return;

  const openLandingPopup = () => {
    landingPopup.classList.add('active');
    popupOverlay.classList.add('active');
    document.body.classList.add('landing-popup-open');
  };

  const closeLandingPopup = () => {
    landingPopup.classList.remove('active');
    popupOverlay.classList.remove('active');
    document.body.classList.remove('landing-popup-open');
  };

  setTimeout(openLandingPopup, 6000);

  popupOverlay.addEventListener('click', closeLandingPopup);
  closeButton.addEventListener('click', closeLandingPopup);
});





function initProductMediaSlider(scope = document) {
  const wrappers = scope.querySelectorAll('.product-gallery-wrapper');

  wrappers.forEach((wrapper) => {
    const mainSlider = wrapper.querySelector('.product-media-slider');
    const thumbSlider = wrapper.querySelector('.product-thumb-slider');

    if (!mainSlider || mainSlider.swiper) return;

    let thumbsSwiper = null;

    if (thumbSlider && !thumbSlider.swiper) {
      thumbsSwiper = new Swiper(thumbSlider, {
        slidesPerView: 5,
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
      });
    } else {
      thumbsSwiper = thumbSlider?.swiper;
    }

    new Swiper(mainSlider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      autoHeight: true,

      navigation: {
        nextEl: mainSlider.querySelector('.swiper-button-next'),
        prevEl: mainSlider.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: mainSlider.querySelector('.swiper-pagination'),
        clickable: true,
      },

      thumbs: thumbsSwiper
        ? {
            swiper: thumbsSwiper,
          }
        : undefined,

      on: {
        init() {
          handleVideo(this);
        },

        slideChangeTransitionEnd() {
          handleVideo(this);
        }
      }
    });
  });
}


// Initial Page Load
document.addEventListener('DOMContentLoaded', () => {
  initProductMediaSlider();
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      if (
        node.matches('.product-media-slider') ||
        node.querySelector('.product-media-slider')
      ) {
        initProductMediaSlider(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

function handleVideo(swiper) {
  // Pause all videos
  swiper.el.querySelectorAll('video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });

  // Get current active DOM slide (works with loop)
  const activeSlide = swiper.slides[swiper.activeIndex];
  const activeVideo = activeSlide.querySelector('video');

  if (activeVideo) {
    activeVideo.play().catch(() => {});
  }
}

/* ------------------------------------------------------------------ *
 * Variant -> Gallery sync
 * Dawn's built-in product-info.js publishes PUB_SUB_EVENTS.variantChange
 * (globals `subscribe` / `PUB_SUB_EVENTS` come from theme assets
 * pubsub.js + constants.js, already loaded on every Dawn page).
 * We listen for that event, find the swiper-slide whose data-media-id
 * matches the newly selected variant's featured_media, and slide there.
 * ------------------------------------------------------------------ */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (!variant || !variant.featured_media) return;

    const sectionId = event?.data?.sectionId;

    document.querySelectorAll('.product-gallery-wrapper').forEach((wrapper) => {
      // Match the wrapper to the section that published the event.
      // Falls back to updating every gallery on the page if no
      // shopify-section ancestor / sectionId is found (safe for
      // single-product pages, quick-view, etc).
      if (sectionId) {
        const section = wrapper.closest('[id^="shopify-section-"]');
        if (section && section.id !== `shopify-section-${sectionId}`) return;
      }

      const mainSlider = wrapper.querySelector('.product-media-slider');
      if (!mainSlider || !mainSlider.swiper) return;

      const targetSlide = mainSlider.querySelector(
        `.swiper-slide[data-media-id="${variant.featured_media.id}"]`
      );
      if (!targetSlide) return;

      const targetIndex = Array.from(mainSlider.querySelectorAll('.swiper-slide')).indexOf(
        targetSlide
      );
      if (targetIndex === -1) return;

      mainSlider.swiper.slideTo(targetIndex);
      // Thumb slider auto-syncs via the `thumbs` module, no extra call needed.
    });
  });
}







var benefitswiper = new Swiper(".partners-image-wrapper", {
  loop:true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  allowTouchMove: false,
  speed: 4000,
  autoplay: {
    delay: 0, 
    disableOnInteraction: false,
    pauseOnMouseEnter: false, 
  },
  breakpoints: {
    749: {
      spaceBetween: 20
    } 
  }
});



var PDPReelSection = new Swiper(".pdp-video-slider", {
  loop:false,
  slidesPerView: 1.5,
  spaceBetween: 15,
  navigation: {
    nextEl: ".pdp-video-slider-block .swiper-button-next",
    prevEl: ".pdp-video-slider-block .swiper-button-prev"
  },
  breakpoints: {
    749: {
      slidesPerView: 3,
      spaceBetween: 20
    } 
  }
});



var IngredientsSlider = new Swiper(".product-ingredients-slider", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 15,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".pdp-video-slider-block .swiper-button-next",
    prevEl: ".pdp-video-slider-block .swiper-button-prev"
  }
});


document.addEventListener('click', function (event) {
  const stickyButton = event.target.closest('.sticky-checkout-button');

  if (!stickyButton) return;

  const productFormButton = document.querySelector('.product-form__submit');

  if (productFormButton) {
    productFormButton.click();
  }
});